import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';

const prefix = 'create';
export default function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_RISK_EVALUATION_SESSIONS_FORM,
  );
  return {
    title: t(`${prefix}.title`),
    backToList: t(`${prefix}.actions.backToList`),
    form: {
      sessionName: t(`${prefix}.fields.sessionName`),
      school: t(`${prefix}.fields.school`),
      year: t(`${prefix}.fields.year`),
      period: t(`${prefix}.fields.period`),
      sessionDate: t(`${prefix}.fields.sessionDate`),
      initDate: t(`${prefix}.fields.initDate`),
      endDate: t(`${prefix}.fields.endDate`),
      description: t(`${prefix}.fields.description`),
      assistants: t(`${prefix}.fields.assistants`),
      assistantsSearch: t(`${prefix}.fields.assistantsSearch`),
    },
    modal: {
      title: t(`${prefix}.modal.title`),
      description: t(`${prefix}.modal.description`),
      form: {
        name: t(`${prefix}.modal.form.name`),
        email: t(`${prefix}.modal.form.email`),
        cancel: t(`${prefix}.modal.form.cancel`),
        submit: t(`${prefix}.modal.form.submit`),
        namePlaceholder: t(`${prefix}.modal.form.namePlaceholder`),
        emailPlaceholder: t(`${prefix}.modal.form.emailPlaceholder`),
      },
      success: t(`${prefix}.modal.success`),
      error: t(`${prefix}.modal.error`),
    },
    actions: {
      saveChanges: t(`${prefix}.actions.saveChanges`),
      addEmail: t(`${prefix}.actions.addEmail`),
    },
    msg: {
      createSuccess: t(`${prefix}.msg.createSuccess`),
      emailDuplicated: t(`${prefix}.errors.emailDuplicated`),
      error: t(`${prefix}.error`),
      success: t(`${prefix}.success`),
    },
  };
}
